import Poller from "shared/services/polling/Poller";
import { useGlobalStore } from "shared/stores/global";
import { useTranscriptRequestsStore } from "shared/stores/transcriptRequests";
import { useUserStore } from "shared/stores/user";

async function callback() {
  if (!useUserStore().isLoggedIn || useGlobalStore().technicalServerError) {
    return;
  }

  await useTranscriptRequestsStore().fetchTranscriptRequestCount();
}

export default new Poller({ callback });
